/**
 * CacheStore — 持久化缓存抽象层。
 *
 * 工厂选择 backend：
 *   1. 优先 IndexedDB（持久化、跨 tab 共享）
 *   2. 不可用时降级 in-memory Map（无持久化，仅本页面有效）
 *
 * 业务代码无感知。详见 OpenSpec add-version-based-cache。
 */

import { indexedDbStore } from './indexeddb';
import { memoryStore } from './memory';
import type { CacheStore } from './types';

function detectIndexedDB(): boolean {
  try {
    return typeof window !== 'undefined' && typeof window.indexedDB !== 'undefined';
  } catch {
    return false;
  }
}

let _store: CacheStore | null = null;

export function getCacheStore(): CacheStore {
  if (_store === null) {
    if (detectIndexedDB()) {
      _store = indexedDbStore;
    } else {
      console.warn('[cacheStore] IndexedDB unavailable; falling back to in-memory store');
      _store = memoryStore;
    }
  }
  return _store;
}

/**
 * Test-only：强制使用指定 backend 重置内部缓存。
 */
export function _setStoreForTests(store: CacheStore | null): void {
  _store = store;
}

export type { CacheStore, CacheStoreEntry, CacheStoreName } from './types';
export { indexedDbStore, memoryStore };
